
import certificacao1 from "./Images/certificacao1.png";
import certificacao2 from "./Images/certificacao2.png";
import ISO from "./Images/ISO.png";
import PBQP from "./Images/PBQP.png";

export default function Cert() {
    return (<div className="fullcert">
        <div className="certmargin">  <h2 className="certtext">Certificações</h2></div>
        <div className="certflex">
      
        <div className="divcert">
        <img className="cert1" src={certificacao1}></img>
        </div>
        <div className="divcert">
        <img className="cert2" src={certificacao2}></img>
        </div>
        <div className="certflex">
        <div className="divcert">
         
   
        <img className="cert3" src={ISO}></img>
        </div>
        <div className="divcert">
        <img className="cert4" src={PBQP}></img>
        </div>
        </div>
    
        </div>
 
    


   </div>)
}